export default __webpack_public_path__ + "static/media/Guesswho2.fa8343ad.PNG";